import { useMenuContext } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import { useLayoutEffect, useMemo, useState } from 'react';
/**
 * Creates a footer registry that tracks footer content.
 * Used by MenuOverlay and MobileBottomSheet to receive content
 * from Menu.Footer children.
 */
export function useMenuFooterRegistry() {
    const [footer, setFooter] = useState(null);
    const registry = useMemo(() => ({ setContent: setFooter }), []);
    return { footer, registry };
}
/**
 * Registers footer content with the nearest MenuProvider.
 * Used by the Menu.Footer compound component.
 */
export function useMenuFooterRegistration(content) {
    const footerRegistry = useMenuContext()?.footerRegistry;
    // WHY useLayoutEffect: synchronously hoist footer content before paint to avoid a flash
    useLayoutEffect(() => {
        footerRegistry?.setContent(content);
        return () => footerRegistry?.setContent(null);
    }, [content, footerRegistry]);
}
//# sourceMappingURL=useMenuFooterRegistry.js.map